import { Box, Button, Tooltip, Typography } from "@material-ui/core";

import { productBaseId } from "../useV4Suggestions";
import {
  v4CatalogChanged,
  v4UnitPrice,
  v4UnitPriceComparison
} from "../v4CatalogReference";
import { v4Money } from "../v4Explanation";
import { v4ReferenceState } from "../v4ReferenceState";
import { isV4ExplicitVector } from "../v4Selection";
import { v4StatusLabel } from "./V4SuggestionDialog";

export default function V4SuggestionCell({ row, state }) {
  const id = productBaseId(row);
  const suggestion = state.results[id];
  const reference = v4ReferenceState(suggestion, state.status);
  if (!id) return <Typography variant="caption">Sem vínculo</Typography>;
  if (state.status === "loading" && !suggestion)
    return (
      <Typography variant="caption" role="status">
        Carregando…
      </Typography>
    );
  if (state.status === "error" && !suggestion)
    return (
      <Box>
        <Typography variant="caption" role="alert" display="block">
          Não foi possível carregar o V4.
        </Typography>
        <Button variant="text" size="small" onClick={state.retry}>
          Tentar V4 novamente
        </Button>
      </Box>
    );
  const statusLabel = v4StatusLabel(suggestion);
  const catalogChanged = v4CatalogChanged(suggestion, row);
  const comparison = v4UnitPriceComparison(suggestion);
  const price =
    reference.hasPrice &&
    ["maintain", "price_hypothesis"].includes(suggestion.stance)
      ? v4UnitPrice(comparison?.suggested_unit_price_brl)
      : null;
  const tooltip = [
    reference.hasPrice
      ? price !== null
        ? `Preço sugerido por unidade da embalagem de ${
            comparison.portion_base
          } porções base${
            isV4ExplicitVector(suggestion)
              ? ", a maior embalagem da decisão V4."
              : ", a mesma usada no P. Atual."
          }`
        : "Preço sugerido por unidade indisponível. Consulte os detalhes da análise."
      : null,
    catalogChanged
      ? "Os preços mudaram desde a análise. Aguarde uma nova decisão."
      : null,
    suggestion?.reason_short || statusLabel,
    reference.hasPrice ? `Análise de ${reference.date}` : null,
    reference.expired ? "Referência vencida; seleção indisponível." : null,
    reference.secondary
  ]
    .filter(Boolean)
    .join(" · ");
  return (
    <Box>
      <Tooltip arrow title={tooltip}>
        <Button
          variant="text"
          size="small"
          color="inherit"
          onClick={() => state.open(row)}
          aria-label={`Ver detalhes V4 de ${row.nome_produto}`}
          style={{
            minWidth: 0,
            textTransform: "none",
            color: "inherit",
            fontSize: "inherit",
            fontWeight: "inherit",
            padding: 0,
            whiteSpace: "nowrap"
          }}
        >
          {price !== null
            ? v4Money(price)
            : reference.hasPrice
            ? "--"
            : statusLabel}
        </Button>
      </Tooltip>
      {catalogChanged ? (
        <Typography variant="caption" color="error" display="block">
          Preços alterados
        </Typography>
      ) : reference.hasPrice && reference.expired ? (
        <Typography variant="caption" color="textSecondary" display="block">
          Vencida
        </Typography>
      ) : null}
      {state.status === "error" && !reference.hasPrice ? (
        <>
          <Typography variant="caption" role="alert" display="block">
            Falha ao atualizar. Exibindo a última consulta.
          </Typography>
          <Button variant="text" size="small" onClick={state.retry}>
            Tentar V4 novamente
          </Button>
        </>
      ) : null}
    </Box>
  );
}
